"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e, forwardRef as i } from "react";
import { useSvgIcon as m } from "../useSvgIcon.js";
const c = e(
  i((r, n) => {
    const { monochrome: t, ...s } = r, L = m({
      ...s,
      ref: n
    });
    return /* @__PURE__ */ o(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...L(),
        children: /* @__PURE__ */ o(
          "path",
          {
            d: "M8 12.5306L21.0775 10.7552L21.0831 23.3306L8.01187 23.4048L8 12.5308V12.5306ZM21.0712 24.7794L21.0813 37.3658L8.01013 35.5742L8.00938 24.695L21.0712 24.7794ZM22.6565 10.5228L39.996 8V23.1706L22.6565 23.3077V10.5228ZM40 24.8978L39.9959 40L22.6564 37.5603L22.6321 24.8695L40 24.8978Z",
            fill: t ? "var(--icon-color)" : "#00ADEF"
          }
        )
      }
    );
  })
);
c.displayName = "IconWindows";
export {
  c as IconWindows
};
